import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-forbbiden',
  templateUrl: './page-forbbiden.component.html',
  styleUrls: ['./page-forbbiden.component.scss']
})
export class PageForbbidenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
